module.exports = __webpack_public_path__ + "static/media/fillipe.a028d22a.jpg";